import {Box, Chip} from "@mui/material";
import AttachFileOutlinedIcon from "@mui/icons-material/AttachFileOutlined";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import React from "react";
import {makeStyles} from "tss-react/mui";
import {useSSTranslation} from "@/i18n/useSSTranslation";
import {
	AnnouncementContentSource,
	getAnnouncementContentIndicators
} from "./announcementContentIndicators";

const useStyles = makeStyles()((theme) => ({
	container: {
		display: "flex",
		flexWrap: "wrap",
		gap: "6px",
		marginBottom: "4px"
	},
	chip: {
		height: 22,
		borderRadius: 100,
		border: `1px solid ${theme.palette.primary.main}`,
		backgroundColor: "transparent",
		color: theme.palette.grey[300],
		fontSize: 12,
		lineHeight: 1,
		fontWeight: 400,
		"& .MuiChip-label": {
			paddingLeft: "4px",
			paddingRight: "8px"
		},
		"& .MuiChip-icon": {
			color: theme.palette.primary.main,
			marginLeft: "6px",
			marginRight: "-2px",
			width: 14,
			height: 14
		}
	}
}));

interface IProps {
	announcement: AnnouncementContentSource;
	className?: string;
}

export const AnnouncementContentChips: React.FC<IProps> = ({announcement, className}) => {
	const {classes, cx} = useStyles();
	const {t} = useSSTranslation();
	const {hasVideo, hasFiles} = getAnnouncementContentIndicators(announcement);

	if (!hasVideo && !hasFiles) {
		return null;
	}

	return (
		<Box
			className={cx(classes.container, className)}
			aria-label="Announcement content indicators"
			data-test-id="announcement-content-chips"
		>
			{hasVideo && (
				<Chip
					size="small"
					className={classes.chip}
					icon={<PlayCircleOutlineIcon sx={{fontSize: 14}} />}
					label={t("announcement_content_video", "Video")}
					data-test-id="announcement-content-chip-video"
				/>
			)}
			{hasFiles && (
				<Chip
					size="small"
					className={classes.chip}
					icon={<AttachFileOutlinedIcon sx={{fontSize: 14}} />}
					label={t("announcement_content_file", "File")}
					data-test-id="announcement-content-chip-file"
				/>
			)}
		</Box>
	);
};
